import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import {
  rest,
  ConfirmationDialog,
  LoadingIndicator,
} from '@xolv-mybrightlink/common';

export const DeleteAccount = () => {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const cancelDialogAction = () => {
    setOpenDialog(false);
  };
  const deleteAction = async () => {
    setOpenDialog(false);
    setLoading(true);
    try {
      await rest.post('/user/delete-account');
    } catch (e) {
      console.debug('Cannot delete account', e);
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return <LoadingIndicator fullHeight overlay />;
  }
  return (
    <>
      <Box sx={{ textAlign: 'center', px: 8, py: 6 }}>
        <Button
          variant='text'
          onClick={() => setOpenDialog(true)}
          sx={{ fontWeight: 500, color: 'error.main' }}
        >
          <FormattedMessage id='account.setting.delete-account' />
        </Button>
      </Box>
      <ConfirmationDialog
        open={openDialog}
        titleId='account.setting.delete-account.title'
        contentId='account.setting.delete-account.confirmation'
        primaryActionTitleId='common.delete'
        primaryAction={deleteAction}
        secondaryActionTitleId='common.cancel'
        secondaryAction={cancelDialogAction}
      />
    </>
  );
};
